module.exports = __webpack_public_path__ + "img/rebuild_yeh_mob4.b4621b48.jpg";